 <template>
  <v-layout row wrap>
    <v-card class="pa-2">
      <v-card-title class="grey lighten-2" primary-title>
        Commssion Details
        <v-spacer></v-spacer>
        <v-btn text icon @click="closeDialog">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-flex xs12>
          <v-container fluid grid-list-lg>
            <v-layout row wrap>
              <v-flex md6 xs12>
                <v-subheader class="queryLabel">{{ comVoucherLabel.comType }}</v-subheader>
                <span class="queryValue">{{ comVoucherDet.comType }}</span>
              </v-flex>
              <v-flex md6 xs12>
                <v-subheader class="queryLabel">{{ comVoucherLabel.voucherNo }}</v-subheader>
                <span class="queryValue">{{ comVoucherDet.voucherNo }}</span>
              </v-flex>
              <v-flex md6 xs12>
                <v-subheader class="queryLabel">{{ comVoucherLabel.comPayRecover }}</v-subheader>
                <span class="queryValue">{{ comVoucherDet.comPayRecover }}</span>
              </v-flex>
              <v-flex md6 xs12>
                <v-checkbox color="primary" :label="comVoucherLabel.comDel" v-model="comVoucherDet.comDel" readonly hide-details></v-checkbox>
              </v-flex>
              <v-flex md12 xs12>
                <v-subheader class="queryLabel">{{ comVoucherLabel.comMatchedBy }}</v-subheader>
                <span class="queryValue">{{ comVoucherDet.comMatchedBy }}</span>
              </v-flex>
              <v-flex md6 xs12>
                <div>{{ comVoucherLabel.billAcct }}</div>
              </v-flex>
              <v-flex md6 xs12>
                <div>{{ comVoucherLabel.overAcct }}</div>
              </v-flex>
              <v-flex md6 xs12>
                <v-subheader class="queryLabel">{{ comVoucherLabel.bAcctNo }}</v-subheader>
                <span class="queryValue">{{ filterAcctNoList(comVoucherDet.bAcctNo) }}</span>
              </v-flex>
              <v-flex md6 xs12>
                <v-subheader class="queryLabel">{{ comVoucherLabel.oAcctNo }}</v-subheader>
                <span class="queryValue">{{ filterAcctNoList(comVoucherDet.oAcctNo) }}</span>
              </v-flex>
              <v-flex md6 xs12>
                <v-subheader class="queryLabel">{{ comVoucherLabel.bBranch }}</v-subheader>
                <span class="queryValue">{{ filterBranchList(comVoucherDet.bBranch) }}</span>
              </v-flex>
              <v-flex md6 xs12>
                <v-subheader class="queryLabel">{{ comVoucherLabel.oBranch }}</v-subheader>
                <span class="queryValue">{{ filterBranchList(comVoucherDet.oBranch) }}</span>
              </v-flex>
              <v-flex md6 xs12>
                <v-subheader class="queryLabel">{{ comVoucherLabel.bTranType }}</v-subheader>
                <span class="queryValue">{{ comVoucherDet.bTranType }}</span>
              </v-flex>
              <v-flex md6 xs12>
                <v-subheader class="queryLabel">{{ comVoucherLabel.oTranType }}</v-subheader>
                <span class="queryValue">{{ comVoucherDet.oTranType }}</span>
              </v-flex>
              <v-flex md6 xs12>
                <v-subheader class="queryLabel">{{ comVoucherLabel.bDocNo }}</v-subheader>
                <span class="queryValue">{{ comVoucherDet.bDocNo }}</span>
              </v-flex>
              <v-flex md6 xs12>
                <v-subheader class="queryLabel">{{ comVoucherLabel.oDocNo }}</v-subheader>
                <span class="queryValue">{{ comVoucherDet.oDocNo }}</span>
              </v-flex>
              <v-flex md6 xs12>
                <v-subheader class="queryLabel">{{ comVoucherLabel.bFund }}</v-subheader>
                <span class="queryValue">{{ filterFundList(comVoucherDet.bFund) }}</span>
              </v-flex>
              <v-flex md6 xs12>
                <v-subheader class="queryLabel">{{ comVoucherLabel.oFund }}</v-subheader>
                <span class="queryValue">{{ filterFundList(comVoucherDet.oFund) }}</span>
              </v-flex>
              <v-flex md6 xs12>
                <v-subheader class="queryLabel">{{ comVoucherLabel.bSuffix }}</v-subheader>
                <span class="queryValue">{{ filterSuffixList(comVoucherDet.bSuffix) }}</span>
              </v-flex>
              <v-flex md6 xs12>
                <v-subheader class="queryLabel">{{ comVoucherLabel.oSuffix }}</v-subheader>
                <span class="queryValue">{{ filterSuffixList(comVoucherDet.oSuffix) }}</span>
              </v-flex>
              <v-flex md6 xs12>
                <v-subheader class="queryLabel">{{ comVoucherLabel.bComm }}</v-subheader>
                <span class="queryValue">{{ comVoucherDet.bComm }}</span>
              </v-flex>
              <v-flex md6 xs12>
                <v-subheader class="queryLabel">{{ comVoucherLabel.oComm }}</v-subheader>
                <span class="queryValue">{{ comVoucherDet.oComm }}</span>
              </v-flex>
              <v-flex md6 xs12>
                <v-subheader class="queryLabel">{{ comVoucherLabel.bOutStdBal }}</v-subheader>
                <span class="queryValue">{{ comVoucherDet.bOutStdBal }}</span>
              </v-flex>
              <v-flex md6 xs12>
                <v-subheader class="queryLabel">{{ comVoucherLabel.oOutStdBal }}</v-subheader>
                <span class="queryValue">{{ comVoucherDet.oOutStdBal }}</span>
              </v-flex>
            </v-layout>
          </v-container>
        </v-flex>
        <v-flex xs12>
          <v-expansion-panels>
            <v-expansion-panel>
              <v-expansion-panel-content class="grey lighten-5">
                <template v-slot:header>
                  <div class="v-icon mdi mdi-plus theme--light d-flex">
                    <span class="headerTitle">Other Details</span>
                  </div>
                </template>
                <v-card>
                  <v-card-text>
                    <v-flex xs12>
                      <v-container fluid grid-list-lg>
                        <v-layout row wrap>
                          <v-flex md6 xs12>
                            <v-subheader class="queryLabel">{{ comVoucherLabel.polNo }}</v-subheader>
                            <span class="queryValue">{{ comVoucherDet.polNo }}</span>
                          </v-flex>
                          <v-flex md6 xs12>
                            <v-subheader class="queryLabel">{{ comVoucherLabel.lastMatchedDate }}</v-subheader>
                            <span class="queryValue">{{ comVoucherDet.lastMatchedDate }}</span>
                          </v-flex>
                          <v-flex md6 xs12>
                            <v-subheader class="queryLabel">{{ comVoucherLabel.tranDate }}</v-subheader>
                            <span class="queryValue">{{ comVoucherDet.tranDate }}</span>
                          </v-flex>
                          <v-flex md6 xs12>
                            <v-subheader class="queryLabel">{{ comVoucherLabel.prem }}</v-subheader>
                            <span class="queryValue">{{ comVoucherDet.prem }}</span>
                          </v-flex>
                          <v-flex md6 xs12>
                            <v-subheader class="queryLabel">{{ comVoucherLabel.netAmt }}</v-subheader>
                            <span class="queryValue">{{ comVoucherDet.netAmt }}</span>
                          </v-flex>
                          <v-flex md6 xs12>
                            <v-subheader class="queryLabel">{{ comVoucherLabel.insRefNoName }}</v-subheader>
                            <span class="queryValue">{{ comVoucherDet.insRefNoName }}</span>
                          </v-flex>
                        </v-layout>
                      </v-container>
                    </v-flex>
                  </v-card-text>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-flex>
        <v-flex xs12>
          <v-container fluid grid-list-lg>
            <v-layout row wrap>
              <v-flex md12 xs12>
                <v-subheader class="queryLabel">{{ comVoucherLabel.createdBy }}</v-subheader>
                <span class="queryValue">{{ comVoucherDet.createdBy }}</span>
              </v-flex>
              <v-flex md12 xs12>
                <v-subheader class="queryLabel">{{ comVoucherLabel.modifiedBy }}</v-subheader>
                <span class="queryValue">{{ comVoucherDet.modifiedBy }}</span>
              </v-flex>
            </v-layout>
          </v-container>
        </v-flex>
      </v-card-text>
    </v-card>
  </v-layout>
</template>

<script>
import * as TableConst from '@/mixins/table'
import { accountsAjaxCalls } from '@/mixins/accounting/accountsAjaxCalls'
import { accountsFilters } from '@/mixins/accounting/accountsFilters'
import { accountsViewMixin } from '@/mixins/accounting/accountsViewMixin'

export default {
  data() {
    return {
      showCommPVList: true,
      showCommPVDetail: false,
      comVoucherLabel: {
        comType: 'Commission Type',
        voucherNo: 'Voucher No.',
        comPayRecover: 'Commission Payable / Recover',
        comDel: 'Commission Deleted',
        comMatchedBy: 'Commission Matched By',
        billAcct: 'Billing Account',
        overAcct: 'Overriding Account',
        bAcctNo: 'Account',
        oAcctNo: 'Account',
        bBranch: 'Branch',
        oBranch: 'Branch',
        bTranType: 'Transaction Type',
        oTranType: 'Transaction Type',
        bDocNo: 'Document No.',
        oDocNo: 'Document No.',
        bFund: 'Fund',
        oFund: 'Fund',
        bSuffix: 'Suffix',
        oSuffix: 'Suffix',
        bComm: 'Commission',
        oComm: 'Commission',
        bOutStdBal: 'Outstanding Balance',
        oOutStdBal: 'Outstanding Balance',
        createdBy: 'CreatedBy',
        modifiedBy: 'ModifiedBy',
        polNo: 'Policy No.',
        curr: 'Currency',
        lastMatchedDate: 'Last Matched Date',
        tranDate: 'Transaction Date',
        prem: 'Premium',
        netAmt: 'Net Amount',
        insRefNoName: 'Insured Reference and Name'
      },
      accountnos: [],
      allbranches: [],
      funds: [],
      acctnosuffixes: []
    }
  },
  watch: {
    boolRefresh: function (value) {
      if (value) {
        this.loadDetail()
      }
    }
  },
  mounted() {
    this.loadDetail()
  },
  methods: {
    loadDetail() {
      this.fetchAccount()
      this.fetchBranch()
      this.fetchFund()
      this.fetchAcctNoSfx()
      this.fetchCommPVData(this.objData)
    },
    closeDialog() {
      this.$emit('close')
    },
    filterAcctNoList(value) {
      const acctno = this.accountnos.find(list => list.value === value)
      return acctno ? acctno.label : ''
    },
    filterBranchList(value) {
      const brn = this.allbranches.find(list => list.value === value)
      return brn ? brn.label : ''
    },
    filterFundList(value) {
      const fund = this.funds.find(list => list.value === value)
      return fund ? fund.label : ''
    },
    filterSuffixList(value) {
      const suffix = this.acctnosuffixes.find(list => list.value === value)
      return suffix ? suffix.label : ''
    }
  },
  computed: {},
  mixins: [TableConst.default, accountsAjaxCalls, accountsFilters, accountsViewMixin],
  props: {
    boolRefresh: {
      type: Boolean,
      default: true
    },
    objData: {
      type: Object,
      default: null
    }
  }
}
</script>
